import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";

import axios from "axios";

import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { onChangeCheckExtensionInstalled } from "../store/slice/preferenceSlice";

import { getUrl } from "../helpers/url";

import { useCmsHook } from "../helpers/cms/cmsHook";
import { cmsConstructor } from "../helpers/cms/cmsConstructor";
import CmsEditBanner from "../helpers/cms/CmsEditBanner";

import { toast } from "react-toastify";

function ExtensionCheck() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const { cmsInstance, setCmsInstance } = useCmsHook();

  useEffect(() => {
    checkExtension({ dispatch, searchParams, setLoading });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/extension-check") {
      const fetchCmsInstance = async () => {
        const cmsObj = await cmsConstructor();
        setCmsInstance(cmsObj);
      };
      fetchCmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-bg-container w-100">
      {window.location.pathname === "/extension-check" && (
        <div className="d-flex flex-row justify-content-center">
          <CmsEditBanner />
        </div>
      )}
      <div className="page-bg-container d-flex flex-column justify-content-center align-items-center w-100">
        <div className="extensions-content-container w-50 p-4">
          {!cmsInstance || loading ? (
            <div className="d-flex flex-row justify-content-center align-items-center my-3">
              <Spinner
                animation="border"
                variant="secondary"
                role="status"
                size="md"
              ></Spinner>
            </div>
          ) : (
            <>
              {cmsInstance &&
                cmsInstance.showRichText(
                  "cmsContent.checkExtension.heading",
                  "extension-heading"
                )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ExtensionCheck;

export const checkExtension = async ({
  dispatch,
  searchParams,
  setLoading,
}) => {
  try {
    setLoading(true);
    const account = searchParams.get("account");
    const { data: res } = await axios.get(getUrl("REACT_APP_CHECK_EXTENSION"), {
      params: {
        account,
      },
    });

    if (res.extensionInstalled) {
      dispatch(
        onChangeCheckExtensionInstalled({ connected: res.extensionInstalled })
      );
    }
  } catch (error) {
    console.log(error.message);
    let errorMessage;
    if (error?.response && error.response?.data?.message)
      errorMessage = error.response.data.message;
    else errorMessage = error.message;
    if (errorMessage === "Request failed with status code 404")
      errorMessage =
        "Your extension is not installed please install the extension to proceed further.";
    toast.error(errorMessage);
  } finally {
    setLoading(false);
  }
};
